/*
 * PluginSelection2ndStep Messages
 *
 * This contains all the text for the PluginSelection2ndStep component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.PluginSelectionModal.PluginSelection2ndStep';

export default defineMessages({
  dropdownPlaceholder: {
    id: `${scope}.dropdownPlaceholder`,
    defaultMessage: 'Select an option',
  },
  linear: {
    id: `${scope}.linear`,
    defaultMessage: 'Linear',
  },
  free: {
    id: `${scope}.free`,
    defaultMessage: 'Free',
  },
  graph: {
    id: `${scope}.graph`,
    defaultMessage: 'Graph',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: 'Continue',
  },
});
